import React from "react";
import { headData } from "../../Data/head";
import { Helmet, HelmetProvider } from "react-helmet-async";

const MetaContainer = () => {
	return (
		<HelmetProvider>
			<Helmet>
				<title>{headData.title}</title>
				<meta name="description" content={headData.description} />
				<meta property="author" content="grizzle" />

				<meta
					name="viewport"
					content="height=device-height,
			                 width=device-width, initial-scale=1.0,
			                 minimum-scale=1.0, maximum-scale=1.0,
			                 user-scalable=no"
				></meta>
				<link href="https://fonts.googleapis.com/css2?family=Inconsolata:wght@200;700&display=swap" rel="stylesheet" />
				<link href="https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;400;700;900&display=swap" rel="stylesheet" />

				<meta property="og:title" content={headData.title} />
				<meta property="og:site_name" content={headData.title} />
				<meta property="og:url" content={headData.url} />
				<meta property="og:description" content={headData.description} />
				<meta property="og:image" content={`${headData.url}thumbnail.png`} />
				<meta property="og:type" content="website" />

				<link rel="apple-touch-icon" href={`${headData.url}forMobile.png`}></link>
				<link rel="shortcut icon" href={`${headData.url}favicon.ico`}></link>
			</Helmet>
		</HelmetProvider>
	);
};

export default MetaContainer;
